import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GridLanguageService {

  constructor(
    private _t : TranslateService
  ) { }

  gridOptions = {
    localeTextFunc: (key, defaultValue) => {
      const value = this.localeText[key]
      return value ? this._t.instant(value) : (value || defaultValue)
    }
  }

  localeText = {
    // Set Filter
    selectAll: this._t.instant('(Select All)'),
    selectAllSearchResults: this._t.instant('(Select All Search Results)'),
    searchOoo: this._t.instant('Search...'),
    blanks: this._t.instant('(Blanks)'),
    noMatches: this._t.instant('No matches'),

    // Number Filter & Text Filter
    filterOoo: this._t.instant('Filter...'),
    equals: this._t.instant('Equals'),
    notEqual: this._t.instant('Not equal'),
    empty: this._t.instant('Choose One'),

    // Number Filter
    lessThan: this._t.instant('Less than'),
    greaterThan: this._t.instant('Greater than'),
    lessThanOrEqual: this._t.instant('Less than or equal'),
    greaterThanOrEqual: this._t.instant('Greater than or equal'),
    inRange: this._t.instant('In range'),
    inRangeStart: this._t.instant('to'),
    inRangeEnd: this._t.instant('from'),

    // Text Filter
    contains: this._t.instant('Contains'),
    notContains: this._t.instant('Not contains'),
    startsWith: this._t.instant('Starts with'),
    endsWith: this._t.instant('Ends with'),

    // Date Filter
    dateFormatOoo: this._t.instant('yyyy-mm-dd'),

    // Filter Conditions
    andCondition: this._t.instant('AND'),
    orCondition: this._t.instant('OR'),

    // Filter Buttons
    applyFilter: this._t.instant('Apply'),
    resetFilter: this._t.instant('Reset'),
    clearFilter: this._t.instant('Clear'),
    cancelFilter: this._t.instant('Cancel'),

    // Filter Titles
    textFilter: this._t.instant('Text Filter'),
    numberFilter: this._t.instant('Number Filter'),
    dateFilter: this._t.instant('Date Filter'),
    setFilter: this._t.instant('Set Filter'),

    // Side Bar
    columns: this._t.instant('Columns'),
    filters: this._t.instant('Filters'),

    // columns tool panel
    pivotMode: this._t.instant('Pivot Mode'),
    groups: this._t.instant('Row Groups'),
    rowGroupColumnsEmptyMessage: this._t.instant('Drag here to set row groups'),
    values: this._t.instant('Values'),
    valueColumnsEmptyMessage: this._t.instant('Drag here to aggregate'),
    pivots: this._t.instant('Column Labels'),
    pivotColumnsEmptyMessage: this._t.instant('Drag here to set column labels'),

    // Header of the Default Group Column
    group: this._t.instant('Group'),

    // Other
    loadingOoo: this._t.instant('Loading...'),
    noRowsToShow: this._t.instant('No Rows To Show'),
    enabled: this._t.instant('Enabled'),

    // Menu
    pinColumn: this._t.instant('Pin Column'),
    pinLeft: this._t.instant('Pin Left'),
    pinRight: this._t.instant('Pin Right'),
    noPin: this._t.instant('No Pin'),
    valueAggregation: this._t.instant('Value Aggregation'),
    autosizeThiscolumn: this._t.instant('Autosize This Column'),
    autosizeAllColumns: this._t.instant('Autosize All Columns'),
    groupBy: this._t.instant('Group by'),
    ungroupBy: this._t.instant('Un-Group by'),
    resetColumns: this._t.instant('Reset Columns'),
    expandAll: this._t.instant('Expand All'),
    collapseAll: this._t.instant('Close All'),
    copy: this._t.instant('Copy'),
    ctrlC: this._t.instant('Ctrl+C'),
    copyWithHeaders: this._t.instant('Copy With Headers'),
    paste: this._t.instant('Paste'),
    ctrlV: this._t.instant('Ctrl+V'),
    export: this._t.instant('Export'),
    csvExport: this._t.instant('CSV Export'),
    excelExport: this._t.instant('Excel Export (.xlsx)'),
    excelXmlExport: this._t.instant('Excel Export (.xml)'),

    // Enterprise Menu Aggregation and Status Bar
    sum: this._t.instant('Sum'),
    min: this._t.instant('Min'),
    max: this._t.instant('Max'),
    none: this._t.instant('None'),
    count: this._t.instant('Count'),
    avg: this._t.instant('Average'),
    filteredRows: this._t.instant('Filtered'),
    selectedRows: this._t.instant('Selected'),
    totalRows: this._t.instant('Total Rows'),
    totalAndFilteredRows: this._t.instant('Rows'),
    more: this._t.instant('More'),
    to: this._t.instant('to'),
    of: this._t.instant('of'),
    page: this._t.instant('Page'),
    nextPage: this._t.instant('Next Page'),
    lastPage: this._t.instant('Last Page'),
    firstPage: this._t.instant('First Page'),
    previousPage: this._t.instant('Previous Page'),

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: this._t.instant('Pivot Chart & Pivot Mode'),
    pivotChart: this._t.instant('Pivot Chart'),
    chartRange: this._t.instant('Chart Range'),

    columnChart: this._t.instant('Column'),
    groupedColumn: this._t.instant('Grouped'),
    stackedColumn: this._t.instant('Stacked'),
    normalizedColumn: this._t.instant('100% Stacked'),

    barChart: this._t.instant('Bar'),
    groupedBar: this._t.instant('Grouped'),
    stackedBar: this._t.instant('Stacked'),
    normalizedBar: this._t.instant('100% Stacked'),

    pieChart: this._t.instant('Pie'),
    pie: this._t.instant('Pie'),
    doughnut: this._t.instant('Doughnut'),

    line: this._t.instant('Line'),

    xyChart: this._t.instant('X Y (Scatter)'),
    scatter: this._t.instant('Scatter'),
    bubble: this._t.instant('Bubble'),

    areaChart: this._t.instant('Area'),
    area: this._t.instant('Area'),
    stackedArea: this._t.instant('Stacked'),
    normalizedArea: this._t.instant('100% Stacked'),

    histogramChart: this._t.instant('Histogram'),

    // Charts
    pivotChartTitle: this._t.instant('Pivot Chart'),
    rangeChartTitle: this._t.instant('Range Chart'),
    settings: this._t.instant('Settings'),
    data: this._t.instant('Data'),
    format: this._t.instant('Format'),
    categories: this._t.instant('Categories'),
    defaultCategory: this._t.instant('(None)'),
    series: this._t.instant('Series'),
    xyValues: this._t.instant('X Y Values'),
    paired: this._t.instant('Paired Mode'),
    axis: this._t.instant('Axis'),
    navigator: this._t.instant('Navigator'),
    color: this._t.instant('Color'),
    thickness: this._t.instant('Thickness'),
    xType: this._t.instant('X Type'),
    automatic: this._t.instant('Automatic'),
    category: this._t.instant('Category'),
    number: this._t.instant('Number'),
    time: this._t.instant('Time'),
    xRotation: this._t.instant('X Rotation'),
    yRotation: this._t.instant('Y Rotation'),
    ticks: this._t.instant('Ticks'),
    width: this._t.instant('Width'),
    height: this._t.instant('Height'),
    length: this._t.instant('Length'),
    padding: this._t.instant('Padding'),
    spacing: this._t.instant('Spacing'),
    chart: this._t.instant('Chart'),
    title: this._t.instant('Title'),
    titlePlaceholder: this._t.instant('Chart title - double click to edit'),
    background: this._t.instant('Background'),
    font: this._t.instant('Font'),
    top: this._t.instant('Top'),
    right: this._t.instant('Right'),
    bottom: this._t.instant('Bottom'),
    left: this._t.instant('Left'),
    labels: this._t.instant('Labels'),
    size: this._t.instant('Size'),
    minSize: this._t.instant('Minimum Size'),
    maxSize: this._t.instant('Maximum Size'),
    legend: this._t.instant('Legend'),
    position: this._t.instant('Position'),
    markerSize: this._t.instant('Marker Size'),
    markerStroke: this._t.instant('Marker Stroke'),
    markerPadding: this._t.instant('Marker Padding'),
    itemSpacing: this._t.instant('Item Spacing'),
    itemPaddingX: this._t.instant('Item Padding X'),
    itemPaddingY: this._t.instant('Item Padding Y'),
    layoutHorizontalSpacing: this._t.instant('Horizontal Spacing'),
    layoutVerticalSpacing: this._t.instant('Vertical Spacing'),
    strokeWidth: this._t.instant('Stroke Width'),
    offset: this._t.instant('Offset'),
    offsets: this._t.instant('Offsets'),
    tooltips: this._t.instant('Tooltips'),
    callout: this._t.instant('Callout'),
    markers: this._t.instant('Markers'),
    shadow: this._t.instant('Shadow'),
    blur: this._t.instant('Blur'),
    xOffset: this._t.instant('X Offset'),
    yOffset: this._t.instant('Y Offset'),
    lineWidth: this._t.instant('Line Width'),
    normal: this._t.instant('Normal'),
    bold: this._t.instant('Bold'),
    italic: this._t.instant('Italic'),
    boldItalic: this._t.instant('Bold Italic'),
    predefined: this._t.instant('Predefined'),
    fillOpacity: this._t.instant('Fill Opacity'),
    strokeOpacity: this._t.instant('Line Opacity'),
    histogramBinCount: this._t.instant('Bin count'),
    columnGroup: this._t.instant('Column'),
    barGroup: this._t.instant('Bar'),
    pieGroup: this._t.instant('Pie'),
    lineGroup: this._t.instant('Line'),
    scatterGroup: this._t.instant('X Y (Scatter)'),
    areaGroup: this._t.instant('Area'),
    histogramGroup: this._t.instant('Histogram'),
    groupedColumnTooltip: this._t.instant('Grouped'),
    stackedColumnTooltip: this._t.instant('Stacked'),
    normalizedColumnTooltip: this._t.instant('100% Stacked'),
    groupedBarTooltip: this._t.instant('Grouped'),
    stackedBarTooltip: this._t.instant('Stacked'),
    normalizedBarTooltip: this._t.instant('100% Stacked'),
    pieTooltip: this._t.instant('Pie'),
    doughnutTooltip: this._t.instant('Doughnut'),
    lineTooltip: this._t.instant('Line'),
    groupedAreaTooltip: this._t.instant('Area'),
    stackedAreaTooltip: this._t.instant('Stacked'),
    normalizedAreaTooltip: this._t.instant('100% Stacked'),
    scatterTooltip: this._t.instant('Scatter'),
    bubbleTooltip: this._t.instant('Bubble'),
    histogramTooltip: this._t.instant('Histogram'),
    noDataToChart: this._t.instant('No data available to be charted.'),
    pivotChartRequiresPivotMode: this._t.instant('Pivot Chart requires Pivot Mode enabled.')
  }

  translate(key, defaultValue) {
    return this._t.instant(key) || defaultValue
  }
}




